export const tpHistoryState: any[] = [
    {label: 'Failed', value: 'Failed'},
    {label: 'Processed', value:'Processed'},
    {label: 'Wait', value: 'Wait'}
  ]
  
  export const tpHistoryResult: any[] = [
    {label: 'ERROR', value: 'ERROR'},
    {label: 'OK', value:'OK'},
  ]